import React, { Component } from 'react'

import { DateRangePicker } from '../../utilites'

class ModalHandbookPrintContent extends Component {
  render(props) {
    return (
      <div>
        <fieldset>
          <div className="d-flex flex-start align-baseline">
            <div>
              <p className="m-r-spacer m-b-spacer"><big>Выданные микрозаймы</big></p>
              <p>Предыдущий №70 от 09.12.2020, Воробьёва Наталья</p>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="">Номер реестра</label>
                <div className="form-element-data number">
                  <input className="input" type="text" name="" id="" />
                </div>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="#">Принятно</label>
                <div className="form-element-data date">
                  <DateRangePicker coverClass={'form-element'} />
                </div>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="#">Подразделение</label>
                <div className="form-element-data">
                  <select className="input">
                    <option>Выберите…</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    )
  }
}

export default ModalHandbookPrintContent
